import React from "react"
import styled from "styled-components"

import { Typography } from "@material-ui/core"

import ButtonLink from "../ButtonLink"
import IoAnimator from "../IoAnimator"

import * as theme from "../../theme"

const ActionBox = ({ headline, link: { url, title, target } }) => {
  return (
    <Container>
      <Headline variant="h2" gutterBottom>
        {headline}
      </Headline>
      <ButtonLink to={url}>{title}</ButtonLink>
    </Container>
  )
}

export default ActionBox

const Container = styled(IoAnimator)`
  @media (min-width: 800px) {
    padding: 60px 5%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 30px 5%;
`
const Headline = styled(Typography)`
  @media (min-width: 800px) {
    margin-bottom: 45px;
  }
  margin-bottom: 35px;
  color: ${theme.color.primary};
`
